<template>
  <div class="search__wrapper">
    <input
      class="search"
      :placeholder="$t('dashboard.search')"
      :value="value"
      @input="updateValue"
      @keyup.esc="clearInput"
    />
    <BaseIcon icon="search" class="search-icon" />
    <BaseIcon
            v-if="value.length > 0"
            v-on:click="clearInput"
            icon="cancel"
            class="search-delete"
            @mouseover="showHelp = true"
            @mouseleave="showHelp = false"
    />
      <transition name="fadeUp">
          <div v-if="showHelp" class="info-box">
              <div class="triangle"></div>
              <span class="help__paragraph" style="margin-top: 0">
                  {{ $t('tooltips.search') }} <span class="highligh">ESC</span>
              </span>
          </div>
      </transition>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'Search',
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      isDirty: false,
      showHelp: false,
    };
  },
  watch: {
    value() {
      this.isDirty = true;
      if (this.value.length === 0) {
        this.showHelp = false;
      }
      this.emitSearchText();
    },
  },
  methods: {
    clearInput() {
      this.$emit('clear');
    },
    updateValue(e) {
      this.$emit('input', e.target.value.trim());
    },
    emitSearchText: debounce(function () {
      this.$emit('onStopTyping');
      this.isDirty = false;
    }, 600),
  },
};
</script>

<style lang="scss" scoped>
@keyframes fade-in {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.search {
  height: 5.5rem;
  width: 38rem;
  border-radius: 0.5rem;
  background-color: $bg;
  border: 1px solid $border-color;
  padding: 0 4rem;
  font-size: 1.6rem;
  font-weight: 500;
  color: #8c8c94;

  &::-webkit-input-placeholder {
    color: #b4b4b4;
    font-style: italic;
  }
}
.search__wrapper {
  position: relative;

  .search-icon {
    position: absolute;
    top: 1.5rem;
    left: 1rem;
    fill: #8c8c94;
  }
  .search-delete {
      position: absolute;
      cursor:pointer;
      top: 2.25rem;
      right: 1rem;
      fill: #bebec6;
      height:1.25rem;
      transition: all 0.15s ease-in-out;
      animation: fade-in 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
      &:hover {
          fill: #8c8c94;
      }
      &:active {
          fill: #bebec6;
      }
  }
}
.info-box {
    position: absolute;
    top: 5rem;
    right: -3.35rem;
    width: 11rem;
    min-height: 0rem;
    background-color: $dark;
    padding: 1.2rem;
    border-radius: 0.5rem;
    color: $grey;
    box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15), 0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);
    text-align: center;

    .triangle {
        position: absolute;
        top: -1.2rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 0;
        height: 0;
        border-left: 1rem solid transparent;
        border-right: 1rem solid transparent;
        border-bottom: 1.2rem solid $dark;
    }
    .help__paragraph {
        font-weight: 400;
        font-size: 1.1rem;
        line-height: 1.5rem;

        .highligh {
            color: $company-color;
        }
    }
    &__title {
        font-size: 1.3rem;
        color: $company-color;
    }
}
</style>
